/**
 * The client chat's timings (shared-client-screens D4 "Chat", rules 6 and 7), one home for the
 * Mini App's chat screen and the website's messages: the stream's reconnect backoff, the
 * fallback poll, the ledger overlap, and the typing line's posting and life.
 */

/** The stream's reconnect delays, the last repeating. */
export const STREAM_BACKOFF_MS = [1_000, 2_000, 5_000, 10_000, 30_000] as const;
/** The fallback poll: 30 s while the stream is up, 10 s while it is down. */
export const POLL_STREAM_UP_MS = 30_000;
export const POLL_STREAM_DOWN_MS = 10_000;
/** A ledger refresh reads this far back before the last server time, so nothing between reads is missed. */
export const LEDGER_OVERLAP_MS = 60_000;
/** The client's typing posts are spaced at least this far apart (the server's bucket is 1 per 3 s). */
export const TYPING_POST_INTERVAL_MS = 3_000;
/** The server's `until` is five seconds ahead; this is the line's life when the device clock disagrees. */
const TYPING_FALLBACK_MS = 5_000;
const TYPING_MAX_MS = 6_000;

/** How long the studio's typing line lasts, from the server's `until`. */
export function typingLineMs(until: string, now: number = Date.now()): number {
  const left = Date.parse(until) - now;
  return Number.isFinite(left) && left > 0 && left <= TYPING_MAX_MS ? left : TYPING_FALLBACK_MS;
}
